import axios from "../../helpers/httpClient";

export default {

    nuevaGestion: async ({ commit, state, dispatch }, data) => {
        const stateData = state.gestiones
        const stateDataUserRoles = state.usersManagementsRoles;

        try {

            // Start loader
            commit('SET_LOADER', true);

            //comprobando que los campos no esten vacios
            if (data.nombre === '' || data.tipo === '') {
                commit('SET_LOADER', false);
                dispatch('activeMessageError', 'Por favor llene los campos vacíos')
                return 'wait'
            }

            //comprobando que el nombre no exceda 30 caracteres

            if (data.nombre.length > 10) {
                commit('SET_LOADER', false);
                dispatch('activeMessageError', 'El nombre no puede exceder los 10 caracteres')
                return 'wait'
            }

            let gestion = await axios.post(`/information/private/crearGestion`, {
                nombreGestion: data?.nombre,
                tipoGestion: data?.tipo,
                rifGestion: data?.rif,
                correoGestion: data?.correo,
                Moneda: data?.currency,
                contribuyente: data?.contribuyente,
                percentage: data?.percentage,
            })

            if (gestion.status === 200) {

                stateData.push(gestion.data.data)
                commit('SET_LOADER', false);
                commit('SET_GESTIONES', stateData)

                // Update Users Managements Roles
                stateDataUserRoles.push(gestion.data.roleAssigned)
                commit('SET_USERS_MANAGEMENTS_ROLES', stateDataUserRoles);
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', stateDataUserRoles);

                dispatch('activeMessageCorrect', gestion.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    eliminaGestion: async ({ commit, state, dispatch }, data) => {
        const stateData = state.gestiones

        try {
            // Start loader
            commit('SET_LOADER', true);

            const gestion = await axios.post(`/information/private/eliminarGestion`, {
                id: data.Id_gestion,
                nombreGestion: data.Nombre_gestion,
                palabra: data.palabraConfirmadora,
            })

            if (gestion.status === 200) {

                stateData.forEach((data2, index) => {
                    if (data2.Id_gestion === data.Id_gestion) {
                        stateData.splice(index, 1)
                    }
                })

                // Stop Loader
                commit('SET_LOADER', false);
                commit('SET_GESTIONES', stateData)
                dispatch('activeMessageCorrect', gestion.data.message)
            }


        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }

    },

    editaGestion: async ({ commit, state, dispatch }, data) => {
        const stateData = state.gestiones

        try {
            // Start loader
            commit('SET_LOADER', true);

            const gestionEditar = await axios.post(`/information/private/editarGestion`, {
                nombreGestionEditar: data?.nombre,
                rifGestionEditar: data?.rif,
                correoGestionEditar: data?.correo,
                id: data?.Id_gestion,
                Metodo_inventario: data?.Metodo_inventario,
                Moneda: data?.currency,
                contribuyente: data?.contribuyente,
                percentage: data?.percentage,
            })

            if (gestionEditar.status === 200) {

                stateData.forEach((data2, index) => {
                    if (gestionEditar.data.data[1] !== undefined) {
                        if (gestionEditar.data.data[1].length > 0) {
                            if (data2.Id_gestion === gestionEditar.data.data[1][0].Id_gestion) {
                                Object.assign(stateData[index], gestionEditar.data.data[1][0])
                            }
                        }
                    } else {
                        if (gestionEditar.data.data.length > 0) {
                            if (data2.Id_gestion === gestionEditar.data.data[0].Id_gestion) {
                                Object.assign(stateData[index], gestionEditar.data.data[0])
                            }
                        }
                    }
                })

                // Stop Loader
                commit('SET_LOADER', false);
                commit('SET_GESTIONES', stateData)
                dispatch('activeMessageCorrect', gestionEditar.data.message)
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }

    },

    setManagementSelected: async ({ commit, dispatch, state }, object) => {
        try {
            commit('SET_MANAGEMENT_SELECTED', object.management);
            commit('SET_CURRENCY_SELECTED', object.currency);
        } catch (error) {
            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateManagementSelected: async ({ commit, dispatch, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const management = await axios.get(`/information/private/management/updateManagementSelected`, {
                params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (management.status === 200) {
                commit('SET_MANAGEMENT_SELECTED', management.data.management);
                commit('SET_USERS_MANAGEMENTS_ROLES', management.data.usersManagementsRoles);
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', management.data.usersManagementsRoles);
                commit('SET_CURRENCY_SELECTED', management.data.currency);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

}